import React from "react";

import { SimpleLinkBlock } from "@reactivated";

import { Clickable } from "../Clickables";
import { Separator } from "../Separator";

import styles from "./MetaData.module.scss";

export const MetaData = ({ children }: React.PropsWithChildren) => (
    <dl className={styles.root}>
        {React.Children.map(children, (child, i) => (
            <>
                {child}
                {i < React.Children.count(children) - 1 && child && (
                    <Separator orientation="horizontal" />
                )}
            </>
        ))}
    </dl>
);
export const MetaDataItem = ({
    label,
    children,
}: React.PropsWithChildren<{ label: React.ReactNode; className?: string }>) => (
    <>
        <dt className={styles.label}>{label}</dt>
        <dd className={styles.text}>{children}</dd>
    </>
);

export const MetaDataPillsItem = ({
    label,
    links,
}: {
    label: React.ReactNode;
    links: Array<SimpleLinkBlock>;
}) =>
    links.length ? (
        <MetaDataItem label={label}>
            {links.map((value, i) => (
                <Clickable key={i} simpleLink={value} className={styles.pill} />
            ))}
        </MetaDataItem>
    ) : null;
